// extracted by mini-css-extract-plugin
export var closeButton = "_ea-1";
export var closeX = "_ea-3";
export var container = "_ea-0";
export var image = "_ea-2";